import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getSectionsAction } from '../actions';
import { useSectionsFormLoaderData } from './SectionsFormLoader';

const {
  useLoader: useSectionsLoader,
  LoaderConsumer: SectionsConsumer,
  LoaderProvider,
} = createLoaderImp({
  action: getSectionsAction,
});

function SectionsLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  const data = useSectionsFormLoaderData();
  const defaultQuery = { ...props.defaultQuery, year: data.currentYear.id };
  return (
    <LoaderProvider {...props} defaultQuery={defaultQuery}>
      {children}
    </LoaderProvider>
  );
}

export { SectionsLoader, SectionsConsumer, useSectionsLoader };
